import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Redirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/'); 
  }, [navigate]);

  return null; // Or a loading spinner if you want
};

export default Redirect;
